/**
 * The feline queen game is using a scratchcards paytable
 * The api delivers a matrix of 9 symbols rather than the needed 3.
 * We always take the first 3 symbols from the matrix unless it is
 * a win in which case we make an array of 3 winning prizes.
 *
 * e.g.
 * From: [5, 1, 1, 9, 7, 8, 4, 2, 5]
 * To:   [5, 1, 1]
 *
 * From: [5, 1, 1, 9, 1, 8, 4, 2, 5]
 * To:   [1, 1, 1]
 *
 */

module.exports = {
    title: 'Feline Queen',
    baseMultiplier: 0.2,

    font: 'ProximaNova',
    fontVariations: ':n4,n7',
    secondaryFont: 'SignPainter',

    parallax: 0,

    backgroundAnchor: {
        x: 0.5,
        y: 0.5,
    },

    hasBackgroundView: true,
    hasForegroundView: false,

    logoYTitle: 0,
    logoZTitle: 0,

    ticketIdX: 0,

    bgColor: 0x0e2b5f,
    primaryColor: 0xf5a620,

    volumes: {
        music: 0.8,
        win: 0.8,
        'sas-louder': 1,
        'spin-button': 0.4,
        'stop-1': 1.0,
        'stop-2': 0.8,
        'stop-3': 0.7,
    },

    styles: {
        introText: {
            fontFamily: 'ProximaNova',
            fontSize: 16,
            fontWeight: 400,
            fill: 0xFFFFFF,
            align: 'center',
            lineHeight: 23,
            wordWrap: true,
            wordWrapWidth: 260,
            stroke: 0x000000,
            strokeThickness: 3,
            lineJoin: 'round',
        },
    },
};




// WEBPACK FOOTER //
// ./themes/fq/config.js